export const GRANT_TYPE = {
  OTP: "otp",
  REFRESH_TOKEN: "refresh_token",
};
